module.exports = __webpack_public_path__ + "images/bb4c0f708288ca471917d033fe92ee0b.png";


//////////////////
// WEBPACK FOOTER
// ./js/components/assets/man/8.png
// module id = 368
// module chunks = 0